import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-survillance',
    imports: [RouterModule],
    templateUrl: './survillance.component.html',
    styleUrls: ['./survillance.component.scss']
})
export class SurvillanceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  
  }

}
